<template>
  <div class="container">
    <div class="selection"  v-if="pagination.total !==0 || keyword!=='' || JSON.stringify(filtersParam) !== '{}'">
      <h4>{{ $t('admin.column.subColumn.title') }}</h4>
      <div class='top' >
        <div>
          <a-input v-model="keyword" @change="search" maxlength="30" :placeholder="$t('admin.column.subColumn.searchPlaceholder')">
            <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
            <img class="clear" v-if="keyword" slot="suffix" @click="keyword = undefined, search()" :src="require('@/assets/icons/icon_gb.png')" />
          </a-input>
        </div>
        <a-button type="primary" @click="create">{{ $t('admin.column.subColumn.create') }}</a-button>
      </div>
    </div>
    <div v-if="pagination.total === 0 && keyword=='' && JSON.stringify(filtersParam) === '{}'" class="nodata">
      <img src='@/assets/img/bj_zanwushujv.png' alt=''>
      <div>
        <div class="text">{{ $t('admin.column.subColumn.noData') }}</div>
        <div v-if="keyword!==''">{{ $t('admin.column.subColumn.searchTip') }}</div>
        <a-button v-else type="primary" @click="create">{{ $t('admin.column.subColumn.create') }}</a-button>
      </div>
    </div>
    <a-table
      v-if="pagination.total !== 0 || keyword!=='' || JSON.stringify(filtersParam) !== '{}'"
      row-key="id"
      @change="tableChange"
      :columns="columns"
      :locale="locale"
      :data-source="data">
      <template slot="order" slot-scope="text, record, index">
        <div class="sort">
         {{record.order?record.order:'--'}}
        </div>
      </template>
      <template slot="type" slot-scope="text, record">
        <span v-if="record.type === 1">{{ $t('admin.column.subColumn.types.news') }}</span>
        <span v-else-if="record.type === 2">{{ $t('admin.column.subColumn.types.experiment') }}</span>
        <span v-else-if="record.type === 3">{{ $t('admin.column.subColumn.types.video') }}</span>
        <span v-else-if="record.type === 4">{{ $t('admin.column.subColumn.types.platform') }}</span>
        <span v-else-if="record.type === 5">{{ $t('admin.column.subColumn.types.externalLink') }}</span>
        <span v-else-if="record.type === 92">{{ $t('admin.column.subColumn.types.recruitment') }}</span>
        <span v-else>{{ $t('admin.column.subColumn.types.resource') }}</span>
      </template>
      <template slot="status" slot-scope="text, record">
        <span v-if="record.status === 1">{{ $t('admin.column.subColumn.status.open') }}</span>
        <span v-else>{{ $t('admin.column.subColumn.status.close') }}</span>
      </template>
      <template slot="operate" slot-scope="text, record">
        <div class="operate">
          <span @click="edit(record)">{{ $t('admin.column.subColumn.actions.edit') }}</span>
          <span @click="delModal(record.id)">{{ $t('admin.column.subColumn.actions.delete') }}</span>
        </div>
      </template>
    </a-table>
    <Pagination
      class="list-pagination"
      :pagination.sync="pagination"
      @handleTableChange="handleTableChange" />
    <TipModal
      @ok="del"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="`
        <p>${$t('admin.column.subColumn.deleteConfirm.title')}</p>
        <p class='placeholder'>${$t('admin.column.subColumn.deleteConfirm.content')}</p>`" />
  </div>
</template>

<script>
import {
  getPortalSubcolumnList,
  postPortalSubclolumnDown,
  postPortalSubclolumnUp,
  getPortalTopcolumnList,
  postPortalSubcolumnDelete
} from '@/api/admin'
import { getListIndex } from '@/utils/other'
import { nameMap } from '@/utils/map'
import { EventBus } from '@/utils/eventBus'
import TipModal from '@/components/tipModal/index.vue'
import Pagination from '@/components/pagination/index.vue'
import debounce from 'lodash.debounce'
import EmptysFind from '@/components/EmptysFind/index.vue'

export default {
  components: {
    TipModal,
    Pagination
  },
  data() {
    return {
      keyword:'',
      delId: undefined,
      delVisible: false,
      columns: [
        {
          title: this.$t('admin.column.subColumn.columns.id'),
          dataIndex: 'index',
          key: 'index'
        },
        {
          title: this.$t('admin.column.subColumn.columns.name'),
          dataIndex: 'title'
        },
        {
          title: this.$t('admin.column.subColumn.columns.parentColumn'),
          dataIndex: 'parentName',
          key: 'parentName',
          filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
          center: true,
          filters: [],
        },
        {
          title: this.$t('admin.column.subColumn.columns.type'),
          dataIndex: 'type',
          key: 'type',
          filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
          center: true,
          filters: [
            { text: this.$t('admin.column.subColumn.types.news'), value: '1' },
            { text: this.$t('admin.column.subColumn.types.experiment'), value: '2' },
            { text: this.$t('admin.column.subColumn.types.video'), value: '3' },
            { text: this.$t('admin.column.subColumn.types.platform'), value: '4' },
            { text: this.$t('admin.column.subColumn.types.externalLink'), value: '5' },
            { text: this.$t('admin.column.subColumn.types.resource'), value: '91' },
            { text: this.$t('admin.column.subColumn.types.recruitment'), value: '92' },
          ],
          scopedSlots: { customRender: 'type' },
        },
        {
          title: this.$t('admin.column.subColumn.columns.status'),
          dataIndex: 'status',
          key: 'status',
          filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
          center: true,
          filters: [
            { text: this.$t('admin.column.subColumn.status.open'), value: '1' },
            { text: this.$t('admin.column.subColumn.status.close'), value: '2' },
          ],
          scopedSlots: { customRender: 'status' },
        },
        {
          title: this.$t('admin.column.subColumn.columns.createdAt'),
          dataIndex: 'createdAt',
        },
        {
          title: this.$t('admin.column.subColumn.columns.sort'),
          dataIndex: 'order',
          scopedSlots: { customRender: 'order' }
        },
        {
          title: this.$t('admin.column.subColumn.columns.operations'),
          dataIndex: 'operate',
          scopedSlots: { customRender: 'operate' }
        }
      ],
      data: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      search: debounce(this.getColumnList, 500),
      filtersParam:{},
      locale: {
        emptyText: <EmptysFind  />
      },
    }
  },
  methods: {
    handleTableChange() {
      this.getColumnList()
    },
    tableChange(p, filters, sort){
      const result = {...{parent_ids:filters.parentName},...{statuses:filters.status},...{type_ids:filters.type}}
      console.log(result)
      this.filtersParam = result
      this.getColumnList()
    },
    create() {
      // if (this.data.length >= 10) {
      //   this.$message.warning('栏目仅限10个')
      //   return
      // }
      this.$router.push({
        name: 'subListAdd'
      })
    },
    async sort(id, type) {
      const data = {
        id
      }
      if (type === 'up') {
        await postPortalSubclolumnUp(data)
      } else {
        await postPortalSubclolumnDown(data)
      }
      this.getColumnList()
      this.$message.success('操作成功！')
    },
    edit(record) {
      this.$router.push({
        name: 'subListAdd',
        query: {
          id: record.id
        }
      })
    },
    delModal(id) {
      this.delVisible = true
      this.delId = id
    },
    del() {
      postPortalSubcolumnDelete({ id: this.delId }).then(res => {
        if (res.code == 200) {
          this.delVisible = false
          this.pagination.page = 1
          this.getColumnList()
          this.$message.success(this.$t('admin.column.subColumn.messages.deleteSuccess'))
          EventBus.$emit('RemoveSubColumn')
        }
      })
    },
    getColumnList() {
      if(this.keyword==undefined){
        this.keyword=''
      }
      const data = {
        page: this.pagination.page,
        keyword:this.keyword,
        ...this.filtersParam
      }
      getPortalSubcolumnList(data).then(res => {
       if (res.code == 200) {
        this.data = getListIndex(res.data.list, this.pagination.page, this.pagination.pageSize)
        nameMap(this.data)
        this.pagination.total = res.data.total
         const hasSearchData = Object.values(this.keyword).some(Boolean)
         if (hasSearchData && res.data.total == 0) {
           this.locale.emptyText = <EmptysFind text={this.$t('table.noSearchResult')} />
         } else {
           this.locale.emptyText = <EmptysFind text={this.$t('noDataEmpty')} />
         }
        const permissionList = localStorage.permissionList
        this.noPermissionModal = !permissionList || !permissionList.includes('admin_column')
       }
     })
    },
    async getTypeList() {
      const res = await getPortalTopcolumnList()
      if (res.code == 200) {
        this.columns[2].filters = res.data.list.map(item => {
          return {
            text: item.title,
            value: item.id
          }
        })


        this.columnList = res.data.list
      }
    }
  },
  async mounted() {
    await this.getTypeList()
    this.getColumnList()
  }
}
</script>

<style lang="less" scoped>
.top{
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.container{
  /deep/ .ant-table {
    min-height: 583px;
  }
  position: relative;
  .list-pagination{
    position: absolute;
    // bottom: 50px;
    width: calc(100% - 44px);
  }
}
h4{
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
}
.admin{
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo{
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down{
    width: 10px;
    margin-left: 5px;
  }
}
.sort{
  display: flex;
  justify-content: center;
  width: 100%;
  color: #5C6F95;
  i:hover{
    color: #FFBFA6;
  }
}
.selection{
  //display: flex;
  //flex-wrap: wrap;
  margin-bottom: 22px;
  //justify-content: space-between;
  /deep/.ant-input,
  /deep/.ant-input-affix-wrapper {
    width: 237px;
    height: 35px;
    color: #000;
    margin-right: 30px;
    border-radius: 20px;
    .ant-input-prefix,
    .ant-input-suffix{
      >img{
        width: 16px;
        cursor: pointer;
      }
    }
    .ant-input-suffix .clear{
      width: 14px;
      height: 14px;
    }
  }
}
.nodata{
  display: flex;
  align-items: center;
  padding-bottom: 70px;
  justify-content: center;
  flex-direction: column;
  height: calc(100% - 120px);
  img{
    width: 285px;
    margin-bottom: 12px;
  }
  >div{
    width: 100%;
    display: flex;
    margin-top: -70px;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .text{
      font-weight: 550;
      color: #0D2340;
      margin-bottom: 12px;
    }
  }
}
/deep/.ant-input-suffix{
  right: 12px;
  img{
    width: 23px;
    cursor: pointer;
  }
}
/deep/.ant-form{
  .ant-form-item{
    margin-bottom: 22px;
    .ant-form-item-label{
      margin-bottom: 6px;
      line-height: normal !important;
    }
    &:last-child{
      margin-bottom: 0;
    }
  }
}
</style>
